// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__1xc89","inner":"Form_inner__31O8a","range":"Form_range__2Tldm","name":"Form_name__3bQJh","actions":"Form_actions__wRwXp"};